/* EarthBased - move the delivery estimate above the countdown, 21 Aug 2026

   WANTED ORDER inside the buy box:
     quantity + Add To Cart -> BUY NOW -> 'Get it between ...' -> countdown

   WHY JS AND NOT CSS
   The countdown (.eb-countdown-product, injected at runtime by eb-countdown.js)
   sits INSIDE form.product-buy, while the delivery estimate is a Custom Liquid
   block that is a SIBLING of the whole add-to-cart summary item. CSS order only
   reorders children of one flex container, so it cannot interleave across two
   different parents. Hence a DOM move.

   The delivery block is matched by its text, not by class: .summary-item
   .custom-liquid is a generic container and the theme may hold more than one.

   The countdown is injected asynchronously, so this retries briefly rather than
   assuming it exists at parse time. The interval self-cancels on success or
   after ~6s; the moved flag makes the move idempotent. If a product has no
   countdown, the delivery block is simply left where the theme put it. */
(function () {
  'use strict';

  function findDelivery() {
    var items = document.querySelectorAll('.product-summary-inner > .summary-item');
    for (var i = 0; i < items.length; i++) {
      if ((items[i].textContent || '').indexOf('Get it between') > -1) return items[i];
    }
    return null;
  }

  function move() {
    var timer = document.querySelector('.eb-countdown-product');
    if (!timer) return false;
    var delivery = findDelivery();
    if (!delivery) return true; /* nothing to move here - stop retrying */
    if (delivery.getAttribute('data-eb-moved') === '1') return true;
    try {
      timer.parentNode.insertBefore(delivery, timer);
      delivery.setAttribute('data-eb-moved', '1');
    } catch (e) { /* leave the original order if the move fails */ }
    return true;
  }

  if (move()) return;
  var tries = 0;
  var iv = setInterval(function () {
    if (move() || ++tries > 40) clearInterval(iv);
  }, 150);
})();
